var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "page-title" }, [_vm._v("我收到的抄送")]),
        _c("div", { staticClass: "page-sub" }, [
          _vm._v(
            "相关审批的知会通知,无需处理 · 未读 " +
              _vm._s(_vm.unreadCount) +
              " 条"
          ),
        ]),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { "margin-top": "12px" },
          attrs: { data: _vm.list },
          on: { "row-click": _vm.goDetail },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", width: "60", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "标题" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    !row.isRead
                      ? _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-right": "6px" },
                            attrs: { size: "mini", type: "primary" },
                          },
                          [_vm._v("未读")]
                        )
                      : _vm._e(),
                    _vm._v(
                      " " + _vm._s(row.title || "审批 #" + row.instanceId) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "抄送时间", prop: "ccTime", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { label: "状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.isRead
                      ? _c("span", { staticStyle: { color: "#909399" } }, [
                          _vm._v("已读"),
                        ])
                      : _c("span", [_vm._v("未读")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.goDetail(row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    !row.isRead
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.markRead(row)
                              },
                            },
                          },
                          [_vm._v("标为已读")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }